export function FeaturesPage() {
  const items = [
    {
      title: "Fight capture",
      body: "Records supported combat telemetry from your Minecraft PvP sessions on Windows.",
    },
    {
      title: "Fight review",
      body: "Timeline, positions, and measured events — confidence labeled when evidence is thin.",
    },
    {
      title: "Coaching",
      body: "Practice recommendations tied to findings, not invented scores.",
    },
    {
      title: "History",
      body: "Local fight history with sync as an optional additive path.",
    },
    {
      title: "Auto-update",
      body: "Ed25519-signed channel on updates.pvpinsight.com for the public Alpha builds.",
    },
    {
      title: "Privacy",
      body: "Local-first by default. Cloud fight storage stays private and authorization-gated.",
    },
  ];

  return (
    <>
      <p className="mono-label">Features</p>
      <h1 className="display">
        Built for
        <br />
        <span className="dim">real duels.</span>
      </h1>
      <p className="lede">
        The desktop app is the product. This site introduces it and gets the Windows build onto your
        machine.
      </p>
      <div className="grid-2">
        {items.map((item) => (
          <article className="card" key={item.title}>
            <h3>{item.title}</h3>
            <p>{item.body}</p>
          </article>
        ))}
      </div>
    </>
  );
}
